import { Banner, Content, Skeleton } from "@patternfly/react-core";
import { useQuery } from "@tanstack/react-query";
import type { FC } from "react";
import { getLoggedinPartnersInfo } from "../../../api/pfs";
import type { IPartnerInfo } from "../../../constants/apiconstants-pfs";
import Env from "../../../utils/env";
import "./DashboardHeader.scss";
import { EMAIL_PREFERENCES } from "../../../constants/DashBoardUrls";

const DashboardHeader: FC = () => {
	const userInfo = (window as any)?.sessionjs?.getuserInfo();
	const fullName = userInfo !== undefined ? `${userInfo?.firstName} ${userInfo?.lastName}` : "";

	const { data: partnerInfo, isLoading } = useQuery<IPartnerInfo>({
		queryKey: ["partnerInfo"],
		queryFn: async ({ signal }) => getLoggedinPartnersInfo(true, signal),
	});
	const companyName = partnerInfo?.accountDisplayName || partnerInfo?.accountName || "";

	const userProfileLink = `${Env.SSOPortal[Env.getEnvName()]}auth/realms/redhat-external/account`;

	return (
		<Banner className="dashboard-header">
			<div className="dashboard-header__content">
				<Content className="dashboard-header__left">
					<Content component={"h1"} className="dashboard-header__title">
						Red Hat Partner Portal
					</Content>
					<Content component={"p"} className="dashboard-header__welcome">
						Welcome, {fullName}
					</Content>
				</Content>
				<div className="dashboard-header__user-card">
					{isLoading ? (
						<>
							<div className="dashboard-header__user-info">
								<Skeleton width="150px" height="1rem" />
								<Skeleton width="100px" height="0.875rem" />
							</div>
							<div className="dashboard-header__user-links">
								<Skeleton width="80px" height="0.875rem" />
								<Skeleton width="160px" height="0.875rem" />
							</div>
						</>
					) : (
						<>
							<div className="dashboard-header__user-info">
								<span className="dashboard-header__user-name">{fullName}</span>
								<span className="dashboard-header__company-name">{companyName}</span>
							</div>
							<div className="dashboard-header__user-links">
								<a
									target={"_blank"}
									href={userProfileLink}
									data-analytics-linktype={"cta"}
									data-analytics-text={"User profile"}
									data-analytics-category={"Dashboard header|User profile"}
									rel="noopener"
								>
									User profile
								</a>
								<a
									href={EMAIL_PREFERENCES}
									data-analytics-linktype={"cta"}
									data-analytics-text={"Update email preferences"}
									data-analytics-category={"Dashboard header|Update email preferences"}
								>
									Update email preferences
								</a>
							</div>
						</>
					)}
				</div>
			</div>
		</Banner>
	);
};

export default DashboardHeader;
